import { DateTime } from 'luxon';

// e.g. `activenewham2019-FacilityUse-MPFB100003`
// See: https://imin-dev.atlassian.net/wiki/spaces/SEAR/pages/2738749441/IDs+in+Agg
const RPDE_ID_FROM_FACILITY_USE_IDENTIFIER_REGEX = /^([^-]+)-FacilityUse-(.+)$/;

// e.g. `activenewham2019-EventSeries-MPFB100003`
// See: https://imin-dev.atlassian.net/wiki/spaces/SEAR/pages/2738749441/IDs+in+Agg
const RPDE_ID_FROM_EVENT_SERIES_IDENTIFIER_REGEX = /^([^-]+)-EventSeries-(.+)$/;

export const deepLinkParamGetters = {
  /**
   * @param {{ startDate: string }} event
   */
  startDateIsoUtc: (event) => ({
    startDateIsoUtc: encodeURIComponent(DateTime.fromISO(event.startDate).toUTC().toISO()),
  }),
  /**
   * @param {Record<string, any>} facilityUse
   */
  facilityUseRpdeId: (facilityUse) => {
    const result = getRpdeIdFromPipelineItemId(
      facilityUse.identifier,
      RPDE_ID_FROM_FACILITY_USE_IDENTIFIER_REGEX
    );
    if (!result) {
      return undefined;
    }
    return {
      facilityUseRpdeId: encodeURIComponent(result),
    };
  },
  /**
   * @param {Record<string, any>} eventSeries
   */
  sessionSeriesRpdeId: (eventSeries) => {
    const result = getRpdeIdFromPipelineItemId(
      eventSeries.identifier,
      RPDE_ID_FROM_EVENT_SERIES_IDENTIFIER_REGEX
    );
    if (!result) {
      return undefined;
    }
    return {
      sessionSeriesRpdeId: encodeURIComponent(result),
    };
  },
};

/**
 * @param {string} identifier
 * @param {RegExp} regex
 * @returns {string | undefined}
 */
function getRpdeIdFromPipelineItemId(identifier, regex) {
  const result = regex.exec(identifier);
  if (!result) {
    return undefined;
  }
  return result[2];
}
